import PerfectScrollbar from 'perfect-scrollbar';

import * as Configuration from '../../../app.constants.js';

NavigationMetricsController.$inject = ['$scope', '$stateParams', '$state', 'MetricCategoryHelperFactory', 'TopToolbarFactory', 'metrics', 'navigationMode', 'MetricsFactory'];
export function NavigationMetricsController($scope, $stateParams, $state, MetricCategoryHelperFactory, TopToolbarFactory, metrics, navigationMode, MetricsFactory) {

  init();

  function initNav() {
    for (let category of metrics) {
      let metrics_list = [];
      if (category.metrics.length) {
        metrics_list = category.metrics;
      } else if (category.subcategories.length) {
        for (let subcat of category.subcategories) {
          metrics_list = metrics_list.concat(subcat.metrics);
        }
      }
      for (let metric of metrics_list) {
        metric.url = urlForMetric(metric.id);
        if ($stateParams.metricId == metric.id) { // == instead of === as we are comparing strings to numbers
          metric.isSelected = true;
          updateCategory(category);
        } else {
          metric.isSelected = false;
        }
      }
    }
  }

  function updateCategory(category) {
    $scope.category = category;
    MetricCategoryHelperFactory.setSelectedCategoryId(category.id, $state.current.name);
  }

  function urlForMetric(metricId) {
    const stateName = MetricsFactory.getMetricsReportStateForMode(navigationMode) + '.metrics';
    return  Configuration.constants.frontendBaseUrl 
          + $state.href(stateName, { metricId, fromReportId: null }); 
  }

  function init() {
    $scope.navigationMode=navigationMode;
    TopToolbarFactory.setSubNavBurger($scope);
    $scope.verbatimURL = Configuration.constants.frontendBaseUrl + $state.href("auth.alcmeon.fuse.verbatim");
    if ($stateParams.metricId) {
      initNav();
      const scrollBar = new PerfectScrollbar('#metrics-subnav-content');
      $scope.$on('$destroy', () => scrollBar.destroy());
    } else if ($state.current.name === 'auth.alcmeon.fuse.verbatim') {
      initNav(); // set isSelected to false for all metrics
      const category = metrics.find(category => category.id === 'metrics/category/statisfaction');
      updateCategory(category);
      $scope.isVerbatimSelected = true;
    } else {
      const stateName = MetricsFactory.getMetricsReportStateForMode(navigationMode) + '.metrics';
      MetricCategoryHelperFactory.routeToBestEffortMetric(metrics, $stateParams.category, stateName);
    }
  }
}
